<template>
    <div class="relative">
        <div class="tabs">
            <div
                role="tablist"
                aria-orientation="horizontal"
                class="tabs__list"
                :style="{
                    'grid-template-columns': `repeat(${props.tabs.length}, minmax(0, 1fr))`,
                    'min-width': `${props.tabs.length * 8}rem`,
                }"
            >
                <div
                    class="absolute top-0 bottom-0 left-0 duration-200 ease-out focus:outline-none"
                    :style="{
                        left: `calc(${selectedTabOffset}%)`,
                        width: `calc(100% / ${props.tabs.length})`,
                    }"
                >
                    <div class="w-full h-full bg-black rounded-full" />
                </div>

                <button
                    v-for="tab in props.tabs"
                    :key="tab.key"
                    type="button"
                    role="tab"
                    class="tabs__button"
                    :class="{
                        'tabs__button--selected': modelSelected === tab.key,
                    }"
                    :tabindex="modelSelected === tab.key ? 0 : -1"
                    :aria-selected="modelSelected === tab.key"
                    :aria-controls="`tab-${tab.key}`"
                    @click.prevent="modelSelected = tab.key"
                >
                    <span>{{ tab.label }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue';

    const props = defineProps({
        tabs: {
            type: Array,
            required: true,
        },
    });

    const modelSelected = defineModel();

    const selectedTabIndex = computed(() => props.tabs.findIndex(tab => tab.key === modelSelected.value));
    const selectedTabOffset = computed(() => (100 / (props.tabs.length)) * selectedTabIndex.value);
</script>

<style lang="postcss">
    .tabs {
        &__list {
            @apply relative border border-black rounded-full p-1 min-h-7 items-center;
            @apply inline-grid grid-flow-col auto-cols-max;
        }

        &__button {
            @apply relative inline-flex items-center justify-center flex-shrink-0 w-full focus:outline-none transition-colors duration-200 ease-out h-full rounded-full;
            @apply uppercase font-semibold tracking-widest text-xs;

            &--selected {
                @apply text-white;
            }
        }
    }
</style>
